/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Form, {
  Item,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  PatternRule,
} from "devextreme-react/form";
// import "./style.scss";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { useAuth } from "../../../contexts/auth";
import { changePassword } from "../../../api/auth";

import { passwordRegex } from "../../../common/regex";

export default function FormApprovalSetting() {
  const [loading, setLoading] = useState(false);
  const formData = useRef({});
  const history = useHistory();
  const { user } = useAuth();
  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      
      const { OldPassword, NewPassword, ConfirmedNewPassword } =
        formData.current;
      setLoading(true);
      if (NewPassword !== ConfirmedNewPassword) {
        setLoading(false);
        notify(
          "New password and confirmed new password are not match",
          "error",
          2000
        );
        return;
      }
      const result = await changePassword(
        user.UserName,
        OldPassword,
        NewPassword
      );
      setLoading(false);
      if (result.isOk) {
        notify(result.message, "success", 2000);
        history.push("/home");
      } else {
        notify(result.message, "error", 2000);
      }
    },
    [history]
  );

  return (
    <div>
      <form className={"login-form"} onSubmit={onSubmit}>
        <Form
          formData={formData.current}
          disabled={loading}
          labelLocation="top"
        >
          <Item
            dataField={"OldPassword"}
            // check password strength
            editorType={"dxTextBox"}
            editorOptions={oldPasswordEditorOptions}
          >
            <RequiredRule message="Old Password is required" />
          </Item>
          <Item
            dataField={"NewPassword"}
            editorType={"dxTextBox"}
            editorOptions={passwordEditorOptions}
          >
            <PatternRule
              message="Password must contain at least 8 characters, including UPPER/lowercase and numbers"
              pattern={passwordRegex}
            />
            <RequiredRule message="New Password is required" />
          </Item>
          <Item
            dataField={"ConfirmedNewPassword"}
            editorType={"dxTextBox"}
            editorOptions={confirmedPasswordEditorOptions}
          >
            <PatternRule
              message="Password must contain at least 8 characters, including UPPER/lowercase and numbers"
              pattern={passwordRegex}
            />
            <RequiredRule message="Password is required" />
          </Item>
          <ButtonItem cssClass="button-rounded mt-3">
            <ButtonOptions
              width={"100%"}
              type={"default"}
              stylingMode="outlined"
              useSubmitBehavior={true}
            >
              <span className="dx-button-text">
                {loading ? (
                  <LoadIndicator
                    width={"24px"}
                    height={"24px"}
                    visible={true}
                  />
                ) : (
                  "Change Password"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>
    </div>
  );
}
const oldPasswordEditorOptions = {
  placeholder: "Old Password",
  mode: "password",
};
const passwordEditorOptions = { placeholder: "Password", mode: "password" };
const confirmedPasswordEditorOptions = {
  placeholder: "Confirm Password",
  mode: "password",
};
